module.exports = __webpack_public_path__ + "static/img/ent-detail-30.869ae3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-30.jpg
// module id = I28z
// module chunks = 52